<div class="dialog-container">
  <div class="dialog-header">
    <div class="dialog-heading flex items-center justify-between">
      <p class="title">Select Scenario</p>
      <i class="pi pi-times cursor-pointer" (click)="onClose(false)"></i>
    </div>
    <span class="sub-title">Choose a scenario you want to open, or click on the plus icon to create a new scenario. </span>
  </div>
  <div class="dialog-content pb-2">
    <div class="mdlz-list">
      <div
        class="mdlz-list-item"
        *ngFor="let scenario of scenarioMasterList"
        (click)="onSelectScenario(scenario)"
        [ngClass]="{
          'selected-item': scenario.scenario_id == selectedScenario?.scenario_id && scenario.iteration_code == selectedScenario?.iteration_code,
          'child-scenario': scenario.parent_scenario_id == 1
        }"
      >
        <div>{{ scenario.scenario_name }}</div>
        <div class="action-icons">
          <span class="time-label">Created on {{ scenario.created_at | date : 'mediumDate' }}</span>
          <span [ngClass]="{ disableScenario: scenario.iteration_code !== data.maxIterationCode }" title="Create Scenario">
            <i class="pi pi-plus icon" (click)="OpenAddScenario($event, scenario.scenario_id, scenario.iteration_code)"></i>
          </span>
          <!-- <i class="pi pi-info-circle icon" (click)="OpenViewScenario(scenario)"></i> -->
          <i class="fa fa-info-circle icon" (click)="OpenViewScenario($event, scenario)" title="View Scenario"></i>
          <span [ngClass]="{ disableScenario: scenario.scenario_id == 1 || scenario.scenario_id == selectedScenario?.scenario_id }" title="Delete Scenario">
            <i class="pi pi-trash icon" (click)="OnDeleteScenario($event, scenario)"></i>
          </span>
        </div>
        <!-- <div class="mdlz-list-child-item"></div> -->
      </div>
    </div>
  </div>
  <div class="dialog-footer">
    <button class="mdlz-btn" (click)="onClose(true)" mat-button>Apply</button>
  </div>
</div>
<div class="card flex justify-content-center">
  <p-confirmDialog #cd class="delete-text" [style]="{ width: '40vw', height: '250px' }">
    <ng-template pTemplate="header">
      <p class="title1 font-bold">Delete Scenario</p>
    </ng-template>
    <ng-template pTemplate="footer">
      <button class="mdlz-btn" (click)="cd.accept()" mat-button>Agree</button>
      <button class="mdlz-btn-outline" (click)="cd.reject()" mat-button>Cancel</button>
    </ng-template>
  </p-confirmDialog>
</div>
